import React from 'react'
import './MCAShareHoldingPattern.css'

const MCAShareHoldingPatternUI = ({shpList}) =>
  <div id='mcaShareHolding' className='g_m_top_200 mca_sh'>
    <span className='g_large'><b>Shareholding Pattern</b></span>
    <table className='g_table'>
      <thead><tr>
        <td><b><Desc name={'particulars'} /></b></td>
        <td className='g_text_right'><b><Desc name={'total'} /></b></td>
        <td className='g_text_right'><b><Desc name={'promoterNumberOfShares'} /></b></td>
        <td className='g_text_right'><b><Desc name={'promoterPercentage'} /></b></td>
        <td className='g_text_right'><b><Desc name={'nonPromoterNumberOfShares'} /></b></td>
        <td className='g_text_right'><b><Desc name={'nonPromoterPercentage'} /></b></td>
      </tr></thead>
      <tbody>
      {
      shpList.map((shp, i) =>
        <RowUI key={i} shp={shp}/>
      )
      }
      </tbody>
    </table>
  </div>

const RowUI = ({shp}) =>

  <tr>
        <td>
          {shp['particulars']}
        </td>
        <td className='g_text_right'>
          {shp['total']}
        </td>
        <td className='g_text_right'>
          {shp['promoterNumberOfShares']}
        </td>
        <td className='g_text_right'>
          {shp['promoterPercentage']}
        </td>
        <td className='g_text_right'>
          {shp['nonPromoterNumberOfShares']}
        </td>
        <td className='g_text_right'>
          {shp['nonPromoterPercentage']}
        </td>
  </tr>

const Desc = ({name}) =>
    <span>
      {(() => {
        switch (name) {
          case 'particulars':
          return 'Particulars'
          case 'total':
          return 'Total'
          case 'promoterNumberOfShares':
          return 'Promoter Shares'
          case 'promoterPercentage':
          return 'Promoter Share %'
          case 'nonPromoterNumberOfShares':
          return 'Non-promoter Shares'
          case 'nonPromoterPercentage':
          return 'Non-promoter Share %'
          default:
            return name
        }
      })()}
    </span>

export default MCAShareHoldingPatternUI
